module.exports = __webpack_public_path__ + "img/shengxiang_logo.01f5d2f0.jpg";